export default {"src":"/_next/static/media/process-search.1ba4852e.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};